import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=5dcef8fa&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=ts&"
export * from "./checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcef8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dcef8fa')) {
      api.createRecord('5dcef8fa', component.options)
    } else {
      api.reload('5dcef8fa', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=5dcef8fa&scoped=true&", function () {
      api.rerender('5dcef8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/bulma/form/field/checkbox.vue"
export default component.exports